import { NgModule } from '@angular/core';
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { clientReducer } from "./reducers/client.reducer";
import { EFFECTS } from "./effects/index";
import { authReducer } from "./reducers/auth.reducer";
import { paymentReducer } from './reducers/payment.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('mainModule', {
      clientState: clientReducer,
      authState: authReducer,
      paymentState: paymentReducer
    }),
    EffectsModule.forFeature(EFFECTS)
  ],
  exports: [],
  declarations: [],
  providers: [],
})
export class NgrxModule { }



// WEBPACK FOOTER //
// ./src/ngrx/ngrx.module.ts